import React, { FC } from 'react';

import { AuthPageWrapper } from 'common/auth/AuthPageLayout';
import { LoginPage } from 'features';

/**
 * A component that represents a login page.
 */
export const Login: FC = () => {
  return (
    <AuthPageWrapper>
      <LoginPage />
    </AuthPageWrapper>
  );
};
